import * as React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

const StyledUl = styled.ul`
  list-style-type: none;
  margin: 0;
`
const StyledLink = styled(Link)`
  color: #000;
  text-decoration: none;
`

const NonSurgical = () => (
  <li>
    <strong>Non-Surgical</strong>
    <StyledUl>
      <li>
        <StyledLink to="/non-surgical-treatments/?treatment=laser">Non-Surgical Laser Treatments</StyledLink>
      </li>
      <li>
        <StyledLink to="/non-surgical-treatments/?treatment=injectables">Injectable Treatments</StyledLink>
      </li>
      <li>
        <StyledLink to="/non-surgical-treatments/?treatment=facials">Facial Treatments</StyledLink>
      </li>
      <li>
        <StyledLink to="/new-advances-for-dry-eye-treatment">Dry Eye Treatments</StyledLink>
      </li>
    </StyledUl>
  </li>
)

export default NonSurgical
